import type { OpeningHourType } from '#base/core/types/OpeningHourType';

const openingHoursFysio: OpeningHourType[] = [
	{
		day: 'monday',
		isOpen: true,
		hourRanges: [
			{
				from: 8.5,
				till: 12,
			},
			{
				from: 12.5,
				till: 18,
			},
			{
				from: 18.5,
				till: 21,
			},
		],
		openingHours: {
			from: 8.5,
			till: 21,
		},
	},
	{
		day: 'tuesday',
		isOpen: true,
		hourRanges: [
			{
				from: 8.5,
				till: 12,
			},
			{
				from: 12.5,
				till: 18,
			},
		],
		openingHours: {
			from: 8.5,
			till: 18,
		},
	},
	{
		day: 'wednesday',
		isOpen: true,
		hourRanges: [
			{
				from: 8.5,
				till: 12,
			},
			{
				from: 12.5,
				till: 18,
			},
			{
				from: 18.5,
				till: 21,
			},
		],
		openingHours: {
			from: 8.5,
			till: 21,
		},
	},
	{
		day: 'thursday',
		isOpen: true,
		hourRanges: [
			{
				from: 8.5,
				till: 12,
			},
			{
				from: 12.5,
				till: 18,
			},
			{
				from: 18.5,
				till: 21,
			},
		],
		openingHours: {
			from: 8.5,
			till: 21,
		},
	},
	{
		day: 'friday',
		isOpen: true,
		hourRanges: [
			{
				from: 8.5,
				till: 12,
			},
			{
				from: 12.5,
				till: 18,
			},
		],
		openingHours: {
			from: 8.5,
			till: 18,
		},
	},
	{
		day: 'saturday',
		isOpen: true,
		hourRanges: [{
			from: 8.5,
			till: 13,
		}],
		openingHours: {
			from: 8.5,
			till: 13,
		},
	},
	{
		day: 'sunday',
		isOpen: false,
	},
];

export default openingHoursFysio;
